import { render, staticRenderFns } from "./NewContactpersonModal.vue?vue&type=template&id=39b0947c"
import script from "./NewContactpersonModal.vue?vue&type=script&lang=js"
export * from "./NewContactpersonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports